import { render, staticRenderFns } from "./PlatText.vue?vue&type=template&id=b9e572c0&scoped=true&"
import script from "./PlatText.vue?vue&type=script&lang=js&"
export * from "./PlatText.vue?vue&type=script&lang=js&"
import style0 from "./PlatText.vue?vue&type=style&index=0&id=b9e572c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e572c0",
  null
  
)

export default component.exports